import React from "react";
import { Link } from "react-router-dom";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import { motion, Variants, Easing } from "framer-motion";

const Footer = () => {
  const ease: Easing = [0.6, -0.05, 0.01, 0.99];

  const containerVariants: Variants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease } },
  };

  return (
    <motion.footer
      className="w-full bg-primaryColor text-white px-4 md:px-8 py-10 md:py-16"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      <div className="max-w-screen-2xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-20">
        {/* Left section: Logo + Intro + Socials */}
        <motion.div
          className="flex flex-col items-center md:items-start gap-4"
          variants={itemVariants}
        >
          {/* <Link to="/">
            <img
              src={require("../assets/ecocyntec.png")}
              alt="Logo"
              className="w-28 md:w-48 object-contain"
            />
          </Link> */}
          <p className="font-CrimsonText font-semibold text-base text-center md:text-left">
            Please don't hesitate to contact us for more information or to
            request a quote. You can also connect with us on social media to
            stay up-to-date on the latest industry news and tips. We look
            forward to serving you.
          </p>
          <div className="flex items-center justify-center md:justify-start gap-4 mt-4">
            <a
              href="https://www.facebook.com/profile.php?id=61585141192609"
              aria-label="Facebook"
              target="_blank"
              rel="noreferrer"
            >
              <FacebookOutlinedIcon fontSize="medium" />
            </a>
            <a
              href="https://x.com/ecocyntec"
              aria-label="Twitter"
              target="_blank"
              rel="noreferrer"
            >
              <XIcon fontSize="medium" />
            </a>
            <a
              href="https://www.instagram.com/ecocyntec"
              aria-label="Facebook"
              target="_blank"
              rel="noreferrer"
            >
              <InstagramIcon fontSize="medium" />
            </a>
            <a
              href="https://www.linkedin.com/company/ecocyntec"
              aria-label="LinkedIn"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedInIcon fontSize="medium" />
            </a>
          </div>
        </motion.div>

        {/* Middle section: Contact Info */}
        <motion.div
          className="flex flex-col items-center justify-start md:items-start gap-6"
          variants={itemVariants}
        >
          <h3 className="w-full font-CrimsonText font-semibold text-lg md:text-xl">
            Contact
          </h3>

          <div className="w-full flex items-start gap-4">
            <FmdGoodOutlinedIcon fontSize="medium" />
            <div>
              <h4 className="font-CrimsonText font-bold text-base md:text-xl">
                Head Office
              </h4>
              <p className="font-CrimsonText text-sm md:text-base">
                1603 Capitol Ave Ste 415
                <br />
                PMB 605565
                <br />
                Cheyenne, Wyoming 82001-4562, USA
              </p>
              <br />
              {/* <p className="font-CrimsonText text-sm md:text-base">
                14 Chestnut Close, Northern Foreshore
                <br />
                Lekki, Lagos, Nigeria
              </p> */}
            </div>
          </div>

          <div className="w-full flex items-start gap-4">
            <MailOutlinedIcon fontSize="medium" />
            <div>
              <h4 className="font-CrimsonText font-bold text-base md:text-xl">
                Email
              </h4>

              {/* <a
                href="mailto:info@ecocyntec.com"
                className="font-CrimsonText text-base text-white hover:underline block"
              >
                info@ecocyntec.com
              </a>
              <a
                href="mailto:inquiries@ecocyntec.com"
                className="font-CrimsonText text-base text-white hover:underline block"
              >
                inquiries@ecocyntec.com
              </a> */}
              <a
                href="mailto:ops@ecocyntec.com"
                className="font-CrimsonText text-base text-white hover:underline block"
              >
                ops@ecocyntec.com
              </a>
            </div>
          </div>

          <div className="w-full flex items-start gap-4">
            <PhoneOutlinedIcon fontSize="medium" />
            <div>
              <h4 className="font-CrimsonText font-bold text-base md:text-xl">
                Phone Number
              </h4>
              <a
                href="tel:+16196934732"
                className="font-CrimsonText text-base text-white hover:underline block"
              >
                +1 (619) 693-4732
              </a>
            </div>
          </div>
        </motion.div>

        {/* Right section: Links + Subscribe */}
        <motion.div
          className="flex flex-col items-center md:items-start gap-8"
          variants={itemVariants}
        >
          <div className="w-full flex flex-col md:flex-row md:justify-between gap-4">
            <div className="flex flex-col gap-2">
              <h3 className="font-CrimsonText font-semibold text-lg md:text-xl">
                Company
              </h3>
              <Link
                to="/aboutUs"
                onClick={() => window.scrollTo(0, 0)}
                className="font-CrimsonText text-base md:text-lg hover:underline"
              >
                About Us
              </Link>
              <Link
                to="/services"
                onClick={() => window.scrollTo(0, 0)}
                className="font-CrimsonText text-base md:text-lg hover:underline"
              >
                Services
              </Link>
              {/* <Link
                to="/projects"
                onClick={() => window.scrollTo(0, 0)}
                className="font-CrimsonText text-base md:text-lg hover:underline"
              >
                Projects
              </Link> */}
              <Link
                to="/contact"
                onClick={() => window.scrollTo(0, 0)}
                className="font-CrimsonText text-base md:text-lg hover:underline"
              >
                Contact
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.footer>
  );
};

export default Footer;
